import {
  type OrganizationBaseModel,
  OrganizationFormSchema,
  type OrganizationWithUppersModel,
} from '@/features/tenant-manager/models';
import type { z } from 'zod';

export const getRecursiveOrganizationWithUpperByKey = (
  data: z.infer<typeof OrganizationWithUppersModel.element>,
  filterKey: keyof z.infer<typeof OrganizationBaseModel>,
): string[] => {
  if (!data.upperOrganization) {
    return [data[filterKey]];
  }
  return [
    data[filterKey],
    ...getRecursiveOrganizationWithUpperByKey(
      data.upperOrganization,
      filterKey,
    ),
  ];
};

export const organizationFormValuesParser = OrganizationFormSchema;
